import { render, staticRenderFns } from "./ReportOutOfStock.vue?vue&type=template&id=330756b1"
import script from "./ReportOutOfStock.vue?vue&type=script&lang=js"
export * from "./ReportOutOfStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports